import { mergeIfNotShallowEqual } from "./createShallowSetState.mjs";
import { getMediaState } from "../hooks/useMedia.mjs";
const subscribeToContextGroup = ({
  disabled = !1,
  setStateShallow,
  pseudoGroups,
  mediaGroups,
  componentContext,
  state
}) => {
  if (pseudoGroups || mediaGroups) {
    const current = {
      pseudo: {},
      media: {}
    };
    return process.env.NODE_ENV === "development" && !componentContext.groups && console.debug("No context group found"), componentContext.groups?.subscribe?.((name, {
      layout,
      pseudo
    }) => {
      if (pseudo && pseudoGroups?.has(String(name))) Object.assign(current.pseudo, pseudo), persist();else if (layout && mediaGroups) {
        const mediaState = getMediaState(mediaGroups, layout),
          next = mergeIfNotShallowEqual(current.media, mediaState);
        next !== current.media && (Object.assign(current.media, next), persist());
      }
      function persist() {
        const group = {
          ...state.group,
          [name]: current
        };
        setStateShallow({
          group
        });
      }
    });
  }
};
export { subscribeToContextGroup };
//# sourceMappingURL=subscribeToContextGroup.mjs.map
